import { makeStyles } from 'tss-react/mui';

export const useArchivedSlideViewStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '85%',
    width: '100%',
    padding: '1rem',
    marginTop: '1rem',
  },
  thumbnailContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '1rem',
    objectFit: 'contain',
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: '1rem',
  },
}));
